import { useEffect } from 'react'

import { useLazyQuery, useReactiveVar } from '@apollo/client'
import { useRouter } from 'next/router'

import { useModal } from '@web/components/Modal/useModal'
import { LanBanner_LineAppNotificationFragment, LineAppNotificationsDocument } from '@web/gql/graphql'
import { darkModeVar } from '@web/hooks/useGlobalDetermineDarkMode'
import { useGlobalStaticStateContext } from '@web/hooks/useGlobalStaticState'
import { apolloClient } from '@web/libs/apollo/client'
import { extractByTypename } from '@web/libs/apollo/typeGuard'
import routes from '@web/libs/constants/routes'
import { isMatchPath } from '@web/libs/matchPath'
import noticeCookie from '@web/libs/noticeCookie'

import { EventPopupContainer } from './EventPopupContainer'
import { LANExposureArea } from '../LANBanner/LANBanner.constant'

export const findEventPopupNotification = (
  lineAppNotifications: LanBanner_LineAppNotificationFragment[],
  darkMode: boolean,
) => {
  return lineAppNotifications.filter(lan => {
    if (darkMode) {
      return lan.exposureArea === LANExposureArea.EVENT_POPUP_DARK
    }

    return lan.exposureArea === LANExposureArea.EVENT_POPUP
  })
}

export const useEventPopup = () => {
  const [getLan] = useLazyQuery(LineAppNotificationsDocument, { client: apolloClient })

  const { isFromNa, isFromMapsApp } = useGlobalStaticStateContext()

  const { openModal } = useModal(EventPopupContainer)
  const router = useRouter()

  const isPathShowable = isMatchPath(router.pathname, {
    path: [routes.HOME, routes.HOME_MY_REVIEW],
    exact: true,
  })

  const darkMode = useReactiveVar(darkModeVar)

  useEffect(() => {
    if (isFromNa) return

    if (!isPathShowable) return

    getLan().then(({ data }) => {
      const { LineAppNotificationsSuccess } = extractByTypename(data?.lineAppNotifications)

      if (!LineAppNotificationsSuccess) return

      const [lineAppNotification] = findEventPopupNotification(
        LineAppNotificationsSuccess.lineAppNotifications,
        darkMode,
      )

      if (!lineAppNotification) return

      if (isFromMapsApp && lineAppNotification.title.includes('저장탭')) return

      const { shouldShow, closeNotice } = noticeCookie({ ...lineAppNotification, maxCloseCount: 1 })

      if (shouldShow) {
        openModal({
          event: lineAppNotification,
          callback: {
            cancel: closeNotice,
          },
        })
      }
    })
  }, [isFromNa, isFromMapsApp, darkMode])
}
